import {ISdkProfileFooterReducer} from "../../interfaces/profile-footer-reducer.interface";
import {ButtonCategory} from "../../../core/enums/button-category.enum";
import {IProfileFooter} from "../../interfaces/profile-footer.interface";
import {IProfileLayoutSelectionMetadata} from "../../interfaces/profile-layout-selection-metadata.interface";
import {ProfilesFooterService} from "../../services/profiles-footer.service";
import {FgppButtonProps} from "../../../core/utils/fgpp-button-props.utils";
import {ButtonType} from "../../../core/enums/button-type.enum";
import {InterfaceTypes} from "../../models/interface-types.model";

export class InterfaceTypesReducer implements ISdkProfileFooterReducer {
  public reduce(buttonCategory: ButtonCategory, footer: IProfileFooter, inputs: IProfileLayoutSelectionMetadata): any {
    const footerService = new ProfilesFooterService().setFooter(footer);
    const buttonList: FgppButtonProps[] = [];
    const requestConnection = new FgppButtonProps('REQ-CONN-CHECK', ButtonType.MENU, 99);
    if (inputs.mode !== 'create' && !inputs.isLocked &&
        inputs.formData &&
        inputs.formData[InterfaceTypes.APPLICATION_PROTOCOL_TP] === 'FED' &&
        inputs.formData[InterfaceTypes.REQUEST_DIRECTION] === 'O' &&
        inputs.formData[InterfaceTypes.REC_STATUS] === 'AC' &&
        inputs.formData[InterfaceTypes.PROFILE_CHANGE_STATUS] === 'NO') {
      buttonList.push(requestConnection);
    }
    return footerService.retain(buttonCategory, buttonList).getFooter();
  }
}
